// extracted by mini-css-extract-plugin
export default {"score":"Score_score__JjfGq"};